import { IFormFooterButtons } from "../../core/types/types";
import flavourConfig from "../../environment/flavourConfig";
import SpinnerButton from "../SpinnerButton/SpinnerButton";

const FormFooterButtons: React.FC<IFormFooterButtons> = ({
  formId,
  submitButtonText,
  cancelButtonText,
  isLoading,
  isSubmitButtonDisabled,
  onSubmitClicked,
  onCancelClicked,
}: IFormFooterButtons) => {
  return (
    <div className="w-full py-4 sm:px-12 px-4 bg-gray-100 mt-6 rounded-b-lg border-t border-gray-200">
      <div className="w-11/12 flex justify-between mx-auto">
        <button
          type="button"
          className={`focus:outline-none w-24 xl:w-28 btn focus:border-${flavourConfig.primaryColor} text-gray-600  border border-gray-300 py-2 mr-4 rounded hover:bg-gray-200 transition duration-150 ease-in-out`}
          onClick={() => onCancelClicked()}
        >
          {cancelButtonText}
        </button>
        <SpinnerButton
          type={formId ? "submit" : "button"}
          formId={formId}
          isLoading={isLoading}
          disabled={isSubmitButtonDisabled}
          onClick={(e) => onSubmitClicked(e)}
        >
          {submitButtonText}
        </SpinnerButton>
      </div>
    </div>
  );
};

export default FormFooterButtons;
